<template>
    <div class="form-group">
        <label class="form-label" :for="id" :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <div class="select-wrapper" :style="{ width: selectWidth }">
            <!-- Version 2 多选样式 -->
            <div v-if="multiple && typeInfo === 'version2'" class="multiple-select-container version2">
                <div class="selected-tags" @click="toggleOptions">
                  <span
                      v-for="(item, index) in selectedItems"
                      :key="item.value"
                      class="tag"
                  >
                    {{ item.name }}
                    <span class="tag-remove" @click.stop="removeTag(index)">×</span>
                  </span>
                </div>
                <div class="multiple-options" v-show="showOptions" :style="{ position: 'absolute', top: '100%', left: '0', width: '100%' }">
                    <div
                        v-for="item in options"
                        :key="item.value"
                        class="option-item"
                        :class="{ 'selected': isSelected(item.value) }"
                        @click="toggleSelection(item.value)"
                    >
                        <span class="checkbox-icon">{{ isSelected(item.value) ? '✓' : '' }}</span>
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- Version 1 多选样式 -->
            <div v-else-if="multiple" class="multiple-select-container version1">
                <div class="selected-tags">
          <span
              v-for="(item, index) in selectedItems"
              :key="item.value"
              class="tag"
          >
            {{ item.name }}
            <span class="tag-remove" @click="removeTag(index)">×</span>
          </span>
                </div>
                <div class="multiple-options">
                    <div
                        v-for="item in options"
                        :key="item.value"
                        class="option-item"
                        :class="{ 'selected': isSelected(item.value) }"
                        @click="toggleSelection(item.value)"
                    >
                        <span class="checkbox-icon">{{ isSelected(item.value) ? '✓' : '' }}</span>
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 单选样式 -->
            <div v-else class="single-select-container">
                <select
                    :disabled="disabled"
                    :id="id"
                    v-model="internalValue"
                    class="filter-select"
                    :required="required"
                    @change="handleChange"
                >
                    <option value="" disabled>{{ '请选择' + placeholder || '-请选择-' }}</option>
                    <option
                        v-for="item in options"
                        :key="item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: true,
        },
        modelValue: {
            type: [String, Array, null],
            default: null,
        },
        options: {
            type: Array,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        labelWidth: {
            type: String,
            default: '40%',
        },
        selectWidth: {
            type: String,
            default: '100%',
        },
        placeholder: {
            type: String,
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        typeInfo: {
            type: String,
            default: "version1",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalValue: this.multiple ? [...(this.modelValue || [])] : (this.modelValue || ''),
            showOptions: false,
        };
    },
    computed: {
        selectedItems() {
            if (!this.multiple || !Array.isArray(this.internalValue)) return [];
            const valueMap = this.options.reduce((map, item) => {
                map[item.value] = item;
                return map;
            }, {});
            return this.internalValue.map(value => valueMap[value] || { name: '未知', value });
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                if (this.multiple) {
                    const newArr = Array.isArray(newValue) ? newValue : [];
                    if (!this.arraysEqual(newArr, this.internalValue)) {
                        this.internalValue = [...newArr];
                    }
                } else {
                    if (newValue !== this.internalValue) {
                        this.internalValue = newValue || '';
                    }
                }
            }
        },
        internalValue: {
            handler(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
    },
    methods: {
        arraysEqual(a, b) {
            if (a.length !== b.length) return false;
            for (let i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) return false;
            }
            return true;
        },
        isSelected(value) {
            if (this.multiple) {
                const stringValue = String(value);
                return Array.isArray(this.internalValue) && this.internalValue.includes(stringValue);
            } else {
                return this.internalValue === value;
            }
        },
        toggleSelection(value) {
            console.log("Before toggle:", this.internalValue, value);
            if (!this.multiple) return;

            if (!Array.isArray(this.internalValue)) {
                this.internalValue = [];
            }
            const stringValue = String(value);
            const index = this.internalValue.indexOf(stringValue);
            if (index > -1) {
                this.internalValue.splice(index, 1);
            } else {
                this.internalValue.push(stringValue);
            }
            console.log("After toggle:", this.internalValue);
        },
        removeTag(index) {
            if (!this.multiple || !Array.isArray(this.internalValue)) return;
            this.internalValue.splice(index, 1);
        },
        handleChange() {
            this.$emit('update:modelValue', this.internalValue);
            this.$emit('change', this.internalValue);
        },
        toggleOptions() {
            this.showOptions = !this.showOptions;
            console.log("selectedItems::",this.selectedItems)
        },
        closeOptions() {
            this.showOptions = false;
        },
        handleOutsideClick(event) {
            if (!this.$el.contains(event.target)) {
                this.closeOptions();
            }
        },
        reset() {
            this.internalValue = '';
            this.$emit('update:modelValue', '');
        },
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    }
};
</script>
<style scoped>
.form-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
    /*margin-right: 0.5rem;*/
    white-space: nowrap;
}

.select-wrapper {
    width: 100%;
    position: relative;
}

/* Version 1 多选样式 */
.multiple-select-container.version1 {
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 6px;
    background: rgb(14, 27, 52);
    padding:0 0.5rem;
}

/* Version 2 多选样式 */
.multiple-select-container.version2 {
    height: 45px;
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 6px;
    background: rgb(14, 27, 52);
}

.selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    height: 40px;
    min-height: 35px;
    align-items: center;
    padding: 0 0.5rem;
    width: 100%;
}

.version1 .selected-tags {
    padding: 0rem;
}

.tag {
    background: #203a5f;
    border-radius: 4px;
    padding: 0.2rem 0.3rem;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    color: #adadad;
    height: 30px;
    font-size: 0.7rem;
}

.tag-remove {
    color: #adadad;
    cursor: pointer;
    font-weight: bold;
    font-size: 1rem;
    line-height: 1;
    transition: color 0.2s;
}

.tag-remove:hover {
    color: #ff5a5a;
}

/* 多选选项列表 */
.multiple-options {
    max-height: 100px;
    overflow-y: auto;
    border-top: 1px dashed rgba(0, 255, 150, 0.2);
    padding-top: 0.5rem;
}
.version2 .multiple-options{
    z-index: 100;
    background: rgb(14, 27, 52);
    border: 1px solid rgba(0, 255, 150, 0.2);
}

.option-item {
    padding: 0.5rem;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #adadad;
}

.option-item:hover {
    background-color: rgba(57, 66, 79, 0.5);
}

.option-item.selected {
    background-color: rgba(0, 255, 150, 0.1);
    border-left: 3px solid #00ff96;
}

.checkbox-icon {
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    text-align: center;
    line-height: 1.2rem;
    border-radius: 3px;
    border: 1px solid rgba(0, 255, 150, 0.5);
}

.option-item.selected .checkbox-icon {
    background-color: rgba(0, 255, 150, 0.2);
    color: #00ff96;
}

/* 单选模式样式 */
.single-select-container {
    position: relative;
}

.filter-select {
    padding: 0 1rem;
    background: rgb(14 27 52);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 6px;
    color: #bebebe;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    appearance: none;  /* 清除默认样式 */
    -moz-appearance: none;  /* 适配 Firefox */
    -webkit-appearance: none;  /* 适配 Safari 和 Chrome */
    height: 45px;
    box-sizing: border-box;
}

.filter-select:focus {
    outline: none;
    border-color: #00ff96;
    box-shadow: 0 0 10px rgba(0, 255, 150, 0.2);
}
</style>
